export default __webpack_public_path__ + "static/media/fiddle-leaf-fig.8c05f69d.jpg";